// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2p1GS","content":"LayoutSettings_content__yioG3"};